/* IRIS custom sort dropdown → drives the hidden native #SortBy <select>.
   Delegated on document so it keeps working after Dawn re-renders the
   facets/grid via AJAX. Setting the select value and dispatching the same
   events the browser fires on a real user selection replicates a native
   sort, so Dawn's existing sorting logic runs untouched. */
(function () {
  if (window.__irisSortInit) return;
  window.__irisSortInit = true;

  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-iris-sort-value]');
    if (!opt) return;

    var select = document.getElementById('SortBy');
    if (!select) return;

    select.value = opt.getAttribute('data-iris-sort-value');
    select.dispatchEvent(new Event('input', { bubbles: true }));
    select.dispatchEvent(new Event('change', { bubbles: true }));

    var details = opt.closest('details');
    if (details) {
      var label = details.querySelector('[data-iris-sort-label]');
      if (label) label.textContent = opt.textContent.trim();
      details.open = false;
    }
  });

  /* Close the dropdown when clicking outside it. */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-iris-sort][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });
})();
